export default __webpack_public_path__ + "static/media/logo-college.0ef229e5.png";